import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba} from '@yandex-delivery/blocks/theme/theme'

export const tag = css`
  border-radius: 100px;
  background-color: ${hex2rgba(cssTheme.colors.warmGray[450].hex, 0.1)};
  transition: background-color 0.1s ease-in-out;

  &:active {
    background-color: ${hex2rgba(cssTheme.colors.absolute.black.hex, 0.1)};
  }
`

export const clickable = css`
  cursor: pointer;
`
